import { Loader } from './Loader';

export async function initializeGame(ident: string = "top_ways81", canvasId: string = 'renderCanvas'){
    const loader = new Loader(canvasId);
    if(ident == "top_ways81"){
        const module = await import(/* webpackChunkName: "top_ways81-chunk" */ './topWays81/GameTopWays81');
        return new module.GameTopWays81(canvasId, ident);
    } else if(ident == "pyramid81"){
        const module = await import(/* webpackChunkName: "pyramid81-chunk" */ './pyramid81/GamePyramid81');
        return new module.GamePyramid81(canvasId, ident);
    } else if(ident == "plinko"){
        const module = await import(/* webpackChunkName: "plinko-chunk" */ './plinko/plinko');
        return new module.Plinko(canvasId);
    } else if(ident == "pyramid20"){
        const module = await import(/* webpackChunkName: "pyramid20-chunk" */ './pyramid20/GamePyramid20');
        return new module.GamePyramid20(canvasId, ident);
    } else if(ident == "pyramiddl20"){
        const module = await import(/* webpackChunkName: "pyramiddl20-chunk" */ './pyramid20-deluxe/GamePyramid20Deluxe');
        return new module.GamePyramid20Deluxe(canvasId, ident);
    } else if(ident == "fullspin9"){
        const module = await import(/* webpackChunkName: "full-spin-chunk" */ './full-spin/GameFullSpin');
        return new module.GameFullSpin(canvasId, ident);
    } else if(ident == "fullspin10"){
        const module = await import(/* webpackChunkName: "full-spin10-chunk" */ './full-spin10/GameFullSpin10');
        return new module.GameFullSpin10(canvasId, ident);
    } else if(ident == "beans81"){
        const module = await import(/* webpackChunkName: "beans81-chunk" */ './beans81/GameBeans81');
        return new module.GameBeans81(canvasId, ident);
    } else if(ident == "beans40"){
        const module = await import(/* webpackChunkName: "beans40-chunk" */ './beans40/GameBeans40');
        return new module.GameBeans40(canvasId, ident);
    } else if(ident == "beans20"){
        const module = await import(/* webpackChunkName: "beans20-chunk" */ './beans20/GameBeans20');
        return new module.GameBeans20(canvasId, ident);
        } else if(ident == "beansdl20"){
        const module = await import(/* webpackChunkName: "beansdl20-chunk" */ './beans20-deluxe/GameBeans20Deluxe');
        return new module.GameBeans20Deluxe(canvasId, ident);
    } else if(ident == "multiballclover"){
        const module = await import(/* webpackChunkName: "multiballclover-chunk" */ './multiball-clover/GameMultiballClover');
        return new module.GameMultiballClover(canvasId, ident);
    } else if(ident == "fruitwalls"){
        const module = await import(/* webpackChunkName: "fruitwalls-chunk" */ './fruitwalls/GameFruitWalls');
        return new module.GameFruitWalls(canvasId, ident);
    } else if(ident == "chocodrop"){
        const module = await import(/* webpackChunkName: "chocodrop-chunk" */ './chocodrop/GameChocoDrop');
        return new module.GameChocoDrop(canvasId, ident);
    }
}